<app-card [headerTitle]="'Neolab sinkronizacija'" [border]="true" [padding]="false" [cardClass]="'height-equal'"
    [cardBodyClass]="'custom-input'">

    <div class="tab" [ngStyle]="{ 'display':  'block'   }">
        <div class="row col-12">
            <div class="text-center mt-2">
                <h6>Period {{dateFrom |date : 'dd.MM.yyyy'}} -
                    {{dateTo |date : 'dd.MM.yyyy'}}</h6>
            </div>

            <div class="text-center mt-3 mb-3">
                <fa-icon size="6x" [icon]="faCircleNotch" animation="spin" class="txt-primary"></fa-icon>
            </div>
        </div>
    </div>
</app-card>